<template>
    <!-- Contractor Modal Modal -->
    <div
id="addListModal" ref="addListModal" class="modal fade" tabindex="-1" aria-labelledby="addListModal"
        aria-hidden="true"
>
        <div
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full"
>
            <div class="modal-content select-none">
                <div class="modal-body !p-3 !pb-5">
                    <div
                        class="relative w-full mobile:h-[70px] tablet:h-[100px] rounded-lg overflow-hidden flex items-center justify-start"
>
                        <button
type="button"
                            class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close"
>
                            <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
                        </button>
                        <div class="relative w-full h-full flex flex-col items-center justify-center">
                            <img
src="../../../assets/images/profile-bg.png"
                                class="w-full object-contain absolute left-0 top-0" alt="backgroundImage"
>
                            <div class="relative flex justify-between items-center w-full z-10 ps-3 !pe-12">
                                <h6 class="m-0 text-xl font-roboto font-semibold text-black-100">
                                    {{ (isEdit) ? 'Edit Affiliate' : 'Add Affiliate' }}
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div
                        class="mobile:max-h-[90vh] desktop:max-h-[70vh] largeDesktop:max-h-[90vh] overflow-y-auto customScrollbar mobile:mt-2 tablet:mt-4"
>
                        <div class="flex flex-col gap-[15px]">
                            <div>
                                <label
for="firstName"
                                    class="text-gray-400 pb-1 font-roboto text-[13px] 2xl:text-[16px]"
>First
                                    Name</label>
                                <inputComponent
ref="firstNameRef" v-model="form.first_name"
                                    placeholder="Enter First Name" required
                                    custom-class="!w-full h-[35px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333]"
/>
                            </div>
                            <div>
                                <label
for="lastName"
                                    class="text-gray-400 pb-1 font-roboto text-[13px] 2xl:text-[16px]"
>Last Name</label>
                                <inputComponent
ref="lastNameRef" v-model="form.last_name" placeholder="Enter Last Name"
                                    required
                                    custom-class="!w-full h-[35px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333]"
/>
                            </div>
                            <div>
                                <label
for="email"
                                    class="text-gray-400 text-[13px] 2xl:text-[16px] pb-1 font-roboto"
>Email</label>
                                <inputComponent
ref="emailRef" v-model="form.email" name="email"
                                    :regex="$constants.EMAIL_REGEX" error-message="Please enter a valid email address"
                                    placeholder="Enter Email" required
                                    custom-class="!w-full h-[35px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333]"
/>
                            </div>
                            <div>
                                <label
for="phoneNo"
                                    class="text-gray-400 pb-1 font-roboto text-[13px] 2xl:text-[16px]"
>Phone No.</label>
                                <inputComponent
ref="phoneRef" v-model="form.phone" name="phone" mask="(###) ###-####"
                                    placeholder="Enter Number" error-message="Invalid phone number" required
                                    custom-class="!w-full h-[35px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333]"
/>
                            </div>
                        </div>
                        <button
class="mt-[30px] mb-0 px-[30px] py-[6px] !w-max mx-auto table rounded-[5px] 2xl:rounded-[6px] text-[#fff] bg-purple-100"
                            @click="submitForm"
>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import inputComponent from '../../partialComponent/inputComponent.vue';
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    components: {
        inputComponent
    },
    emits: ["update"],
    data() {
        return {
            isEdit: false,
            form: {
                "first_name": "",
                "last_name": "",
                "email": "",
                "phone": "",
                "distribution_frequency": "monthly"
            }
        }
    },

    computed: {
        ...mapGetters([
            "affiliateDetails",
        ]),
    },
    watch: {
        affiliateDetails: function (data) {
            toast.success(this.isEdit ? "Updated Successfully." : "Added Successfully.");
            if (this.modal)
                this.modal.hide();
            this.$emit('update', true);
        }

    },
    methods: {
        ...mapActions([
            "addAffiliate",
            "editAffiliate"
        ]),
        validateForm() {
            let inputRefer = ["firstNameRef", "lastNameRef", "emailRef", "phoneRef"]
            let hasError = false;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });
            if (
                this.$helper.isEmpty(this.form.first_name) ||
                this.$helper.isEmpty(this.form.last_name) ||
                this.$helper.isEmpty(this.form.email) ||
                this.$helper.isEmpty(this.form.phone)
            ) {
                hasError = true;
            }

            return hasError;
        },

        submitForm() {

            if (!this.validateForm()) {
                if (this.isEdit) {
                    this.editAffiliate(this.form)
                } else {
                    this.addAffiliate(this.form)
                }

            }
        },

        editModal(data) {
            this.reset()
            this.form = JSON.parse(JSON.stringify(data)), 
            this.isEdit = true
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.addListModal;

            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
            });

            this.modal.show();
        },

        openModal() {
            this.reset()
            this.isEdit = false
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.addListModal;

            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
            });

            this.modal.show();
        },

        reset() {
            this.form = {
                "first_name": "",
                "last_name": "",
                "email": "",
                "phone": "",
                "distribution_frequency": "monthly"
            }
        }
    }
}
</script>